import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { cityTypes, cityActions } = createActionsStructure('city', [
  { name: 'GET_ALL_CITIES', async: true },
  { name: 'DISABLE_CITY', async: true },
  { name: 'GET_ROUTE_CITIES', async: true },
  { name: 'CLEAR_ROUTE_CITIES', async: false },
  { name: 'SET_SYSTEM_CITY', async: true },
  { name: 'UPDATE_CITY_STATION', async: false },
  { name: 'SET_CITY_STATION', async: true },
  { name: 'UPDATE_CITY_TIME', async: false },
  { name: 'SET_CITY_TIME', async: true },
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/CityActions.js